import { envConfig } from "../../config/env.config";
import { IBaseResponseModel } from "../../models/common/models.type";
import api from "../remote/baseApi";

const baseURL = envConfig.N8N_BACKEND_ENDPOINT;

export interface IGoogleConnection {
    id: string;
    email: string;
    name: string;
    picture?: string;
    n8nCredentialId: string;
    n8nCredentialName: string;
    createdAt: string;
}

export interface IGetAuthUrlResponse {
    success: boolean;
    authUrl: string;
}

/**
 * Get Google OAuth authorization URL
 */
const getAuthUrl = (
    clientId: string,
    clientSecret: string
): Promise<IBaseResponseModel<IGetAuthUrlResponse>> => {
    return api.post(baseURL, "/api/auth/google", { clientId, clientSecret });
};

/**
 * Get all Google connections for current user
 */
const getConnections = (): Promise<IBaseResponseModel<IGoogleConnection[]>> => {
    return api.get(baseURL, "/api/google-connections");
};

/**
 * Disconnect a Google account
 */
const disconnectAccount = (
    connectionId: string
): Promise<IBaseResponseModel<void>> => {
    return api.delete(baseURL, `/api/google-connections/${connectionId}`);
};

/**
 * Test n8n connection
 */
const testN8NConnection = (): Promise<
    IBaseResponseModel<{ connected: boolean; message: string }>
> => {
    return api.get(baseURL, "/api/auth/test-n8n");
};

/**
 * Open OAuth popup and handle connection
 */
const openOAuthPopup = (authUrl: string): Promise<boolean> => {
    return new Promise((resolve) => {
        const width = 500;
        const height = 600;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        const popup = window.open(
            authUrl,
            "google-oauth",
            `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`
        );

        // Poll for popup close
        const checkClosed = setInterval(() => {
            if (popup?.closed) {
                clearInterval(checkClosed);
                resolve(true);
            }
        }, 500);

        // Timeout after 5 minutes
        setTimeout(() => {
            clearInterval(checkClosed);
            popup?.close();
            resolve(false);
        }, 5 * 60 * 1000);
    });
};

const GoogleOAuthService = {
    getAuthUrl,
    getConnections,
    disconnectAccount,
    testN8NConnection,
    openOAuthPopup
};

export default GoogleOAuthService;